import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import type { PapiNetworkbarStrip } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import Surface from '@wix/da-ds/pkg/Surface';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import DeviationShopCard from '@wix/da-shared-react/pkg/ShopCard/DeviationShopCard';
import { useMeasuredMobileSwipeCookie } from '../useMeasuredMobileSwipeCookie';
import TitledStrip, { cardWidth } from '../../_partials/TitledStrip';
import s from './RecommendedSellStrip.scss';

interface Props {
  strip: PapiNetworkbarStrip;
  className?: string;
}

const RecommendedSellStrip: React.FC<Props> = ({ strip, className }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { ref, dimensions } = useMeasuredMobileSwipeCookie();

  return (
    <Surface
      elevation={ThemeSurface.SECONDARY}
      className={c(s['root'], className)}
    >
      <TitledStrip
        title={t('shopPage.sellYourArt.strips.recommendedSellStrip.heading')}
        description={t(
          'shopPage.sellYourArt.strips.recommendedSellStrip.description'
        )}
        className={s['content']}
      >
        {strip.deviations &&
          strip.deviations.map(deviation => (
            <div
              key={deviation.deviationId}
              className={s['center-for-mobile-slider']}
              ref={ref}
            >
              <DeviationShopCard
                deviation={deviation}
                width={isMobile ? dimensions.width ?? cardWidth : cardWidth}
                detailsRightSlot={
                  <BuyButton
                    size="large"
                    rounded
                    href={Url.deviationLink(deviation.deviationId)}
                  >
                    {t(
                      'shopPage.sellYourArt.strips.recommendedSellStrip.sellButton.label'
                    )}
                  </BuyButton>
                }
              />
            </div>
          ))}
      </TitledStrip>
    </Surface>
  );
};

RecommendedSellStrip.displayName = 'RecommendedSellStrip';

export default RecommendedSellStrip;
